module.exports = __webpack_public_path__ + "static/media/upgrade-vps.0b88c665.png";